/*
 * ============================
 * File: index.js
 * Project: Octavia-Admin
 * File Created: Thursday, 9th April 2020 2:11:05 am
 * Author:UILIB
 * AuthorUrl:https://ui-lib.com/
 * -----
 * Last Modified: Saturday, 18th April 2020 9:32:52 pm
 * Modified By: naime hossain (naime.hossain93@gmail.com)
 * -----
 * Copyright 2020 - 2021 UILIB, UILIB
 * ============================
 */

// Imports
import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import AuthGuard from './auth-guard';
import SuspendedGuard from '@/router/suspended-guard';

Vue.use(Router);

export const halloweenPaths = [
  '/sx-5free',
  '/sx-halloween',

  '/tmb-5free',
  '/tmb-halloween',

  '/op-5free',
  '/op-halloween',
];

export const landingPages = ['/olympus-plinko', '/fast-mines', '/thanksgiving', '/black-friday', '/cyber-monday'];

export const footerPages = [
  '/about',
  '/helpcenter',
  '/contact',
  '/tnc',
  '/privacypolicy',
  '/crypto',
  '/responsible-gaming',
];

const filterRoutes = (routes) =>
  routes
    .filter((route) => route.active !== 'false' && route.active !== false)
    .map((route) => {
      if (route.children) {
        route.children = filterRoutes(route.children);
      }

      return route;
    });

const routes = filterRoutes([
  {
    name: 'emailverification',
    path: '/verifyemail',
    component: () => import('@/components/VerifyEmail.vue'),
    props: (route) => ({
      verificationCode: route.query.verificationCode,
      email: route.query.email,
      signinCode: route.query.signinCode,
    }),
  },
  {
    path: '/game_error',
    name: 'GameError',
    component: () => import('@/views/app/dashboard/GameError'),
  },
  {
    path: '/addFriends',
    name: 'addFriends',
    component: () => import('@/views/app/dashboard/AddFriends'),
    beforeEnter: SuspendedGuard,
  },
  {
    path: '/',
    component: () => import('@/views/app/Index'),
    children: [
      {
        path: '',
        name: 'homepage',
        meta: {
          breadcrumb: [{ name: 'Dashboard' }, { name: 'Lets Play' }],
        },
        component: () => import('@/views/app/dashboard/dashboard/views/index.vue'),
        beforeEnter: SuspendedGuard,
      },
      {
        path: '/cashier',
        name: 'cashier',
        component: () => import('@/views/cashier/index.vue'),
        beforeEnter: (to, from, next) => {
          if (!AuthGuard(to, from, next)) {
            return false;
          }
          SuspendedGuard(to, from, next);
        },
      },
      {
        path: 'helpcenter',
        name: 'helpcenter',
        meta: {
          breadcrumb: [{ name: 'Help Center' }],
        },
        component: () => import('@/views/app/dashboard/footer-pages/help-center/HelpCenter.vue'),
      },
      {
        path: 'responsible-gaming',
        name: 'responsible-gaming',
        meta: {
          breadcrumb: [{ name: 'Help Center' }],
        },
        component: () => import('@/views/app/dashboard/footer-pages/responsible-gaming/ResponsibleGaming.vue'),
      },
      {
        path: 'rsg-tools',
        name: 'rsg-tools',
        component: () => import('@/views/app/dashboard/account/views/rsg-tools.vue'),
        beforeEnter: SuspendedGuard,
      },
      {
        name: 'affiliate',
        path: 'affiliate/:partnername',
        props: { default: true },
        component: () => import('@/views/app/dashboard/dashboard/views/index.vue'),
        beforeEnter: SuspendedGuard,
      },
      {
        path: 'contact',
        name: 'contact',
        meta: {
          breadcrumb: [{ name: 'Apps' }, { name: 'Contact' }],
        },
        component: () => import('@/views/app/dashboard/contact'),
      },
      {
        path: 'lobby',
        name: 'lobby',
        component: () => import('@/views/app/dashboard/dashboard/views/index.vue'),
        beforeEnter: SuspendedGuard,
      },
      {
        path: 'playerrewards',
        name: 'playerrewards',
        redirect: 'lobby',
      },
      {
        path: 'maxblastchamps',
        name: 'maxblastchamps',
        redirect: 'lobby',
        // meta: {
        //   breadcrumb: [{ name: 'Games' }, { name: 'maxblastchamps' }],
        // },
        // component: () => import('@/views/app/dashboard/maxblastchamps'),
        // beforeEnter: (to, from, next) => {
        //   if (!AuthGuard(to, from, next)) {
        //     return false;
        //   }
        //   SuspendedGuard(to, from, next);
        // },
      },
      {
        path: 'challengefriends',
        redirect: 'challenge-friends',
        beforeEnter: (to, from, next) => {
          if (!AuthGuard(to, from, next)) {
            return false;
          }
          SuspendedGuard(to, from, next);
        },
      },
      {
        path: 'challengefriends/challenge',
        redirect: 'challenge-friends',
        beforeEnter: (to, from, next) => {
          if (!AuthGuard(to, from, next)) {
            return false;
          }
          SuspendedGuard(to, from, next);
        },
      },
      {
        path: 'challenge-friends',
        name: 'challenge-friends',
        component: () => import('@/views/challenge-friends/index.vue'),
        beforeEnter: (to, from, next) => {
          if (!AuthGuard(to, from, next)) {
            return false;
          }
          SuspendedGuard(to, from, next);
        },
      },
      {
        path: 'challengefriends/:component',
        name: 'challengefriends',
        component: () => import('@/views/app/dashboard/challenge-friends/views/index.vue'),
        beforeEnter: (to, from, next) => {
          if (!AuthGuard(to, from, next)) {
            return false;
          }
          SuspendedGuard(to, from, next);
        },
      },
      {
        path: 'packages',
        name: 'packages',
        meta: {
          breadcrumb: [{ name: 'Packages' }],
        },
        component: () => import('@/views/app/dashboard/Packages.vue'),
        beforeEnter: (to, from, next) => {
          if (!AuthGuard(to, from, next)) {
            return false;
          }
          SuspendedGuard(to, from, next);
        },
      },
      {
        path: 'referfriends',
        name: 'referfriends',
        meta: {
          breadcrumb: [{ name: 'Friends' }],
        },
        component: () => import('@/views/app/dashboard/referfriendsNew'),
        beforeEnter: (to, from, next) => {
          if (!AuthGuard(to, from, next)) {
            return false;
          }
          SuspendedGuard(to, from, next);
        },
      },
      {
        path: 'friendsrequest',
        name: 'friendsrequest',
        meta: {
          breadcrumb: [{ name: 'Friends' }],
        },
        component: () => import('@/views/app/dashboard/friendsrequest'),
        beforeEnter: (to, from, next) => {
          if (!AuthGuard(to, from, next)) {
            return false;
          }
          SuspendedGuard(to, from, next);
        },
      },
      {
        path: 'about',
        name: 'about',
        meta: {
          breadcrumb: [{ name: 'About' }],
        },
        component: () => import('@/views/app/dashboard/AboutNew.vue'),
      },
      {
        path: 'tnc',
        name: 'tnc',
        meta: {
          breadcrumb: [{ name: 'Terms & Conditions' }],
        },
        component: () => import('@/views/app/dashboard/footer-pages/tnc/Tnc.vue'),
      },
      {
        path: 'sweeps-rules',
        name: 'sweeps-rules',
        meta: {
          breadcrumb: [{ name: 'Sweeps Rules' }],
        },
        component: () => import('@/views/app/dashboard/SweepsRules.vue'),
      },
      {
        path: 'profileuser/:component',
        name: 'profileuser-component',
        meta: {
          breadcrumb: [{ name: 'user' }],
        },
        component: () => import('@/views/app/dashboard/account/views/index.vue'),
        beforeEnter: AuthGuard,
      },
      {
        path: 'profileuser',
        name: 'profileuser',
        redirect: 'profileuser/yourprofile',
      },
      {
        path: 'privacypolicy',
        name: 'privacypolicy',
        meta: {
          breadcrumb: [{ name: 'privacypolicy' }],
        },
        component: () => import('@/views/app/dashboard/footer-pages/privacy-policy/PrivacyPolicy.vue'),
      },
      {
        path: 'crypto',
        name: 'crypto',
        meta: {
          breadcrumb: [{ name: 'Crypto' }],
        },
        component: () => import('@/views/app/dashboard/footer-pages/crypto/Crypto.vue'),
      },
      {
        path: 'comingsoon',
        name: 'comingsoon',
        component: () => import('@/views/ComingSoon.vue'),
      },
      {
        name: 'resetPassword',
        path: '/resetPassword',
        component: () => import('@/views/app/dashboard/dashboard/views/index.vue'),
        props: (route) => ({
          resetPasswordCode: route.query.resetPasswordCode,
        }),
      },
      {
        path: '/app/apps',
        component: () => import('@/views/app/apps/Index'),
        children: [
          {
            path: 'chat',
            name: 'chat',
            component: () => import('@/views/app/apps/Chat'),
            meta: {
              breadcrumb: [{ name: 'Apps' }, { name: 'Chat' }],
            },
          },
          {
            path: 'file-manager',
            name: 'file-manager',
            meta: {
              breadcrumb: [{ name: 'Apps' }, { name: 'File Manager' }],
            },
            component: () => import('@/views/app/apps/FileManager'),
          },
        ],
      },
      {
        path: '',
        component: () => import('@/views/app/Index'),
        redirect: '/',
      },
      ...halloweenPaths.map((path) => ({
        path,
        component: () => import('@/views/Halloween.vue'),
      })),
      ...landingPages.map((path) => ({
        path,
        name: path.replace('/', ''),
        redirect: '/',
        //component: () => import('@/views/landings/GamesLandingPage.vue'),
      })),
      {
        path: '/discord',
        name: 'discord',
        component: () => import('@/views/Discord.vue'),
      },
      {
        path: '/July4th',
        name: 'July4th',
        component: () => import('@/views/July4th.vue'),
      },
      {
        path: '/tmb',
        name: 'TripleMaxBlast',
        redirect: 'lobby',
        component: () => import('@/views/TripleMaxBlast.vue'),
      },
      {
        path: 'games',
        name: 'games-lobby-all',
        meta: {
          category: 'all',
        },
        component: () => import('@/views/lobbies/GameCategoryLobbyView'),
        beforeEnter: (to, from, next) => {
          if (!AuthGuard(to, from, next)) {
            return false;
          }
          SuspendedGuard(to, from, next);
        },
      },
      {
        path: 'fastplay',
        name: 'games-lobby-fastplay',
        redirect: 'lobby',
        // meta: {
        //   category: 'fastplay',
        // },
        // component: () => import('@/views/lobbies/GameCategoryLobbyView'),
        // beforeEnter: (to, from, next) => {
        //   if (!AuthGuard(to, from, next)) {
        //     return false;
        //   }
        //   SuspendedGuard(to, from, next);
        // },
      },
      {
        path: 'fish-table-games',
        name: 'games-lobby-ftg',
        meta: {
          category: 'ftg',
        },
        component: () => import('@/views/lobbies/GameCategoryLobbyView'),
        beforeEnter: (to, from, next) => {
          if (!AuthGuard(to, from, next)) {
            return false;
          }
          SuspendedGuard(to, from, next);
        },
      },
      {
        path: 'playervsplayer',
        name: 'games-lobby-pvp',
        meta: {
          category: 'pvp',
        },
        component: () => import('@/views/lobbies/GameCategoryLobbyView'),
        beforeEnter: (to, from, next) => {
          if (!AuthGuard(to, from, next)) {
            return false;
          }
          SuspendedGuard(to, from, next);
        },
      },
      {
        path: 'lobby/dragonstone',
        name: 'lobby-dragonstone',
        meta: {
          gameType: 'dragonstone',
        },
        component: () => import('@/views/lobbies/GameLobbyView'),
        beforeEnter: (to, from, next) => {
          if (!AuthGuard(to, from, next)) {
            return false;
          }
          SuspendedGuard(to, from, next);
        },
      },
      {
        path: 'lobby/mission-amazon',
        name: 'lobby-mission-amazon',
        meta: {
          gameType: 'mission-amazon',
        },
        component: () => import('@/views/lobbies/GameLobbyView'),
        beforeEnter: (to, from, next) => {
          if (!AuthGuard(to, from, next)) {
            return false;
          }
          SuspendedGuard(to, from, next);
        },
      },
      {
        path: 'lobby/sector-x',
        name: 'lobby-sector-x',
        meta: {
          gameType: 'sector-x',
        },
        component: () => import('@/views/lobbies/GameLobbyView'),
        beforeEnter: (to, from, next) => {
          if (!AuthGuard(to, from, next)) {
            return false;
          }
          SuspendedGuard(to, from, next);
        },
      },
      {
        path: 'lobby/plinko',
        name: 'lobby-plinko',
        meta: {
          gameType: 'plinko',
        },
        component: () => import('@/views/lobbies/GameLobbyView'),
        beforeEnter: (to, from, next) => {
          if (!AuthGuard(to, from, next)) {
            return false;
          }
          SuspendedGuard(to, from, next);
        },
      },
      {
        path: 'lobby/maxblast',
        name: 'lobby-maxblast',
        meta: {
          gameType: 'maxblast',
        },
        component: () => import('@/views/lobbies/GameLobbyView'),
        beforeEnter: (to, from, next) => {
          if (!AuthGuard(to, from, next)) {
            return false;
          }
          SuspendedGuard(to, from, next);
        },
      },
      {
        path: 'lobby/multi-mines',
        name: 'lobby-multi-mines',
        meta: {
          gameType: 'multi-mines',
        },
        component: () => import('@/views/lobbies/GameLobbyView'),
        beforeEnter: (to, from, next) => {
          if (!AuthGuard(to, from, next)) {
            return false;
          }
          SuspendedGuard(to, from, next);
        },
      },
      {
        path: '*',
        name: 'Not Found',
        component: () => import('@/views/NotFound'),
      },
    ],
  },
]);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    document.getElementById('app')?.scrollIntoView();
  },
  routes,
});

router.beforeEach((to, from, next) => {
  const isUserBanned = store.getters.isUserBanned;
  const disabledInfo = store.state.user?.disabled;

  if (isUserBanned || typeof disabledInfo === 'object') {
    if (['/contact', '/'].includes(to.path)) {
      next();
    } else {
      next({ path: '/' });
    }
  } else {
    next();
  }
});

router.afterEach((to) => {
  // Google Analytics integration
  if (typeof window.gtag === 'function') {
    // Send a pageview event to Google Analytics
    window.gtag('config', process.env.VUE_APP_GTAG_ID, { page_path: to.fullPath });
  }

  // Complete the animation of the route progress bar or perform other actions
  // setTimeout(() => store.dispatch('changeThemeLoadingState', false), 500);
  store.dispatch('changeThemeLoadingState', false);
});

const originalPush = Router.prototype.push;

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => {
    if (process.env.NODE_ENV === 'development') {
      console.error('[DEVELOPMENT ONLY ERROR BELOW]');
      console.error(err);
    }
  });
};

export default router;
